/*
* Function to get the time form the Date string in the format hh:mm
*/
Date.prototype.getTimeStr = function () {
    let minutes = this.getMinutes();
    let hours = this.getHours();
    hours = hours >= 10 ? hours:`0${hours}`;
    minutes = minutes >= 10 ? minutes:`0${minutes}`;
    return `${hours}:${minutes}`;
}

/*
* Function to change only the time field of the date Object.
* Takes in the 'time' (string) that is to be set and updates the date Object
*/
Date.prototype.changeTime = function (time) {
    this.setHours(time.split(':')[0], time.split(':')[1]);
    return this;
}

/*
* Function to Added hours from a given time.
* Takes in 'h' (integer, Number of hours to be added) and gives back recalculated date object
*/
Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
}

/*
* Function to convert the Date Object to AET
*/
Date.prototype.toAET = function () {
    let hrsToAdd = this.getTimezoneOffset() / 60 + 11
    this.addHours(hrsToAdd);
    return this;
}

/*
* Function to Subtract hours from a given time.
* Takes in 'h' (integer, Number of hours to be subtracted) and gives back recalculated date object
*/
Date.prototype.subtractHours = function (h) {
    this.setTime(this.getTime() - (h * 60 * 60 * 1000));
    return this;
}

/*
* Translate the date object to string format yyyy-mm-ddThh:mm:ss
*/
Date.prototype.formatToISOString = function () {
  let formatDate = this.formatDateToISOString();
  return `${formatDate}T${this.toTimeString().split(' ')[0]}`;
}

/*
 * Translate the date object to string format yyyy-mm-dd
 */
Date.prototype.formatDateToISOString = function () {
  let month = this.getMonth()+1;
  let date = this.getDate();
  month = month > 9 ? month : `0${month}`;
  date = date > 9 ? date : `0${date}`;
  return `${this.getFullYear()}-${month}-${date}`;
}

/*
* Translate the date object to string format 'DD MonthName YYYY hh:mm'
*/
Date.prototype.getDateTimeStr = function () {
    return `${this.toDateString()} ${this.getTimeStr()}`;
}

/*
* Takes in date string of the format YYYY - MM - DD with an optional delimiter
* Returns a string of the format DD - MMM - YYYY
*/
Date.prototype.toDDMMMYYYY = function (delimiter = '-') {
    let splitDate = this.toString().split(' ');
    return `${splitDate[2]}${delimiter}${splitDate[1]}${delimiter}${splitDate[3]}`;
}

/*
* Takes in date object
* Returns a string of the format Day DD MMM YYYY
*/
Date.prototype.toDayDDMMMYYYY = function () {
    let dateString = '';
    dateString = this.toDateString().split(' ');
    return `${dateString[0]} ${dateString[2]} ${dateString[1]} ${dateString[3]}`;
}

/*
* Takes in offset in sec and returns the date object with the offset added to the UTC date
*/
Date.prototype.changeOffset = function (offset) {
    let curDate = new Date(),

    // convert to msec, add local time zone offset & get UTC time in msec
    utcDate = curDate.getTime() + (curDate.getTimezoneOffset() * 60000),

    // create new Date object for different city using supplied offset
    dateWithOffset = new Date(utcDate + parseInt(offset)*1000);

    return dateWithOffset
  }
